import React from 'react';
import Routes from 'src/routes/routes';

function App(): JSX.Element {
  return <Routes />;
}

export default App;
